import "./FullScreenLoader.scss";
import PropTypes from "prop-types";
import React from "react";

const FullScreenLoader = ({ children }) => {
  return (
    <div className="fullscreen-loader-wrapper">
      <div className="loader-container">{children}</div>
    </div>
  );
};

FullScreenLoader.propTypes = {
  children: PropTypes.element,
};

export default FullScreenLoader;
